;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="2d189fae-d0db-4e31-bbe8-43acbf736f3a",e._sentryDebugIdIdentifier="sentry-dbid-2d189fae-d0db-4e31-bbe8-43acbf736f3a")}catch(e){}}();
{
  var _sentryModuleMetadataGlobal =
    typeof window !== "undefined"
      ? window
      : typeof global !== "undefined"
      ? global
      : typeof self !== "undefined"
      ? self
      : {};

  _sentryModuleMetadataGlobal._sentryModuleMetadata =
    _sentryModuleMetadataGlobal._sentryModuleMetadata || {};

  _sentryModuleMetadataGlobal._sentryModuleMetadata[new _sentryModuleMetadataGlobal.Error().stack] =
    Object.assign(
      {},
      _sentryModuleMetadataGlobal._sentryModuleMetadata[new _sentryModuleMetadataGlobal.Error().stack],
      {"_sentryBundlerPluginAppKey:petsdeli-sentry":true}
    );
}
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[893],{

/***/ 24981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var hooks_common_use_mobile__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44621);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


/**
 * Returns padding value and shouldApplyPadding function to use with product cards in a product grid.
 */ var useBestsellerStyleProperties = function(param) {
    var bestsellerProductsLength = param.bestsellerProductsLength;
    var isMobile = (0,hooks_common_use_mobile__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), bestSellerWrapperMessageHeight = ref[0], setBestSellerWrapperMessageHeight = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var element = document.getElementById("bestSellerWrapperMessage");
        if (element) {
            setBestSellerWrapperMessageHeight(element.offsetHeight);
        }
        return function() {
            setBestSellerWrapperMessageHeight(null);
        };
    }, [
        bestsellerProductsLength
    ]);
    var shouldApplyPadding = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(index) {
        return Boolean(!isMobile && bestSellerWrapperMessageHeight && (bestsellerProductsLength === 1 && index < 2 || bestsellerProductsLength === 2 && index < 1 || bestsellerProductsLength === 3 && index < 0));
    }, [
        bestsellerProductsLength,
        bestSellerWrapperMessageHeight,
        isMobile
    ]);
    var paddingValue = bestSellerWrapperMessageHeight ? bestSellerWrapperMessageHeight + 24 : 0;
    return {
        paddingValue: paddingValue,
        shouldApplyPadding: shouldApplyPadding
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useBestsellerStyleProperties);


/***/ }),

/***/ 79137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ laptop; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/assets/icons/bin.svg
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function SvgBin(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.34 1.523a2.391 2.391 0 00-1.624.877 2.446 2.446 0 00-.462.953c-.054.24-.056.27-.06.854l-.005.545-1.034.001c-.568.001-1.893.004-2.944.008l-1.91.006-.067.022a.78.78 0 00-.51.53 1.092 1.092 0 00-.005.364.784.784 0 00.515.549l.067.022 1.322.003 1.323.003.003 7.043.002 7.044.02.12a2.382 2.382 0 002.098 2.006c.13.014 11.732.014 11.862 0 .38-.04.774-.185 1.087-.4.136-.094.223-.167.345-.29a2.441 2.441 0 00.67-1.346c.015-.093.016-.552.019-7.138l.003-7.04 1.322-.002 1.322-.003.067-.022a.784.784 0 00.515-.549c.02-.077.017-.286-.004-.365a.781.781 0 00-.51-.529l-.068-.022-1.91-.006c-1.05-.004-2.376-.007-2.944-.008l-1.034-.001-.004-.545c-.004-.574-.006-.606-.055-.833a2.613 2.613 0 00-.332-.787 2.373 2.373 0 00-1.26-.959 2.357 2.357 0 00-.342-.085c-.106-.02-.111-.02-2.775-.022-1.467 0-2.684 0-2.702.002zm.13 1.498a.998.998 0 00-.412.16c-.083.06-.194.182-.243.267a1.007 1.007 0 00-.107.296c-.006.037-.01.252-.01.535v.473h6.605v-.473c0-.284-.005-.497-.01-.535a.863.863 0 00-.234-.46.923.923 0 00-.414-.242l-.077-.022-2.534-.002c-1.394 0-2.548 0-2.563.003zM5.454 13.234c0 6.33.001 6.982.015 7.049a.858.858 0 00.223.426.897.897 0 00.426.25l.08.022h11.606l.08-.022a.887.887 0 00.654-.703c.007-.043.01-2.241.01-7.03V6.26H5.453v6.975zm3.95-3.591a.766.766 0 00-.573.573c-.018.09-.018 6.723 0 6.812.053.256.262.48.52.56.062.02.093.023.217.023a.596.596 0 00.216-.022.776.776 0 00.515-.548c.017-.07.017-.24.017-3.419 0-3.184 0-3.349-.017-3.419a.778.778 0 00-.51-.546 1.038 1.038 0 00-.385-.014zm4.867 0a.767.767 0 00-.568.56c-.016.07-.017.235-.017 3.429v3.355l.022.076c.073.251.265.45.51.526.063.019.093.022.217.022a.596.596 0 00.216-.022.77.77 0 00.52-.559c.019-.079.019-6.737 0-6.816a.772.772 0 00-.515-.557 1.038 1.038 0 00-.384-.014z",
    fill: "currentColor"
  })));
}
/* harmony default export */ var bin = (SvgBin);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./src/tracking/index.ts
var tracking = __webpack_require__(1975);
// EXTERNAL MODULE: ./src/tracking/gtm/index.ts + 1 modules
var gtm = __webpack_require__(71295);
// EXTERNAL MODULE: ./src/modules/collection/components/filter-group/index.tsx
var filter_group = __webpack_require__(7589);
;// CONCATENATED MODULE: ./src/modules/collection/components/collection-filter/laptop/index.tsx






var FilterLaptop = function(param) {
    var appliedFilter = param.appliedFilter, filterConfig = param.filterConfig, activeAllergyFilter = param.activeAllergyFilter, resetFilter = param.resetFilter, toggleFilter = param.toggleFilter, collectionProducts = param.collectionProducts, visibleProducts = param.visibleProducts;
    var numberOfActiveFilters = appliedFilter.length + activeAllergyFilter.length;
    if (!filterConfig) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-test": "collection-filter",
        className: "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-4 flex items-center justify-between text-xs",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-sm font-medium leading-[21px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "cdp:filter:label"
                        })
                    }),
                    numberOfActiveFilters > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: "flex shrink-0 items-center gap-2 text-xs font-medium leading-[18px] text-text-secondary",
                        onClick: function() {
                            (0,gtm/* gtm */.w)((0,tracking/* selectElement */.G7)({
                                element: [
                                    "Filter",
                                    "Unselect All"
                                ]
                            }));
                            resetFilter();
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(bin, {
                                className: "inline-block h-3 w-3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: "cdp:resetfilters"
                            })
                        ]
                    })
                ]
            }),
            filterConfig && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-auto px-0",
                children: filterConfig && /*#__PURE__*/ (0,jsx_runtime.jsx)(filter_group/* default */.Z, {
                    filterConfig: filterConfig,
                    toggleFilter: toggleFilter,
                    appliedFilter: appliedFilter,
                    collectionProducts: collectionProducts,
                    visibleProducts: visibleProducts
                })
            })
        ]
    });
};
/* harmony default export */ var laptop = (FilterLaptop);


/***/ }),

/***/ 25827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ collection_filter_mobile; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(80969);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/assets/icons/filter.svg
var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function SvgFilter(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#filter_svg__clip0_1290_1717)"
  }, /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.133.336a1.608 1.608 0 00-1.344.893l-.042.085H3.66c-3.421 0-3.124-.002-3.228.032a.609.609 0 00-.25.16.614.614 0 00-.166.553c.051.24.224.422.458.486l.057.015 3.108.002 3.108.001.033.07a1.604 1.604 0 002.905-.015l.025-.053.88-.002.88-.003.038-.01a.61.61 0 00.303-.171.578.578 0 00.153-.248.85.85 0 00.023-.087.837.837 0 00-.003-.22.63.63 0 00-.416-.477c-.101-.034-.047-.032-.999-.032h-.858l-.029-.06a1.607 1.607 0 00-1.55-.92zm-4.499 4.06a1.617 1.617 0 00-1.34.969c0 .004-.271.006-.872.007-.865.001-.872.002-.915.012a.633.633 0 00-.373.235.623.623 0 00.297.97c.101.034.02.032.986.033l.872.002.038.078a1.605 1.605 0 002.896-.012l.031-.066 3.1-.002c2.968-.001 3.103-.001 3.138-.01a.632.632 0 00.49-.74.638.638 0 00-.488-.488l-.043-.01-3.1-.003-3.1-.003-.023-.05a1.61 1.61 0 00-1.258-.915 2.417 2.417 0 00-.336-.006zm4.507 4.056a1.602 1.602 0 00-1.352.894l-.042.085H3.66c-2.792 0-3.091.001-3.132.008a.627.627 0 00-.511.74.627.627 0 00.506.493c.042.007.313.008 3.135.008h3.09l.006.015c.03.074.107.21.168.296a1.613 1.613 0 002.4.244c.145-.133.282-.321.365-.503l.023-.05.88-.002.88-.003.048-.013a.598.598 0 00.293-.169.577.577 0 00.153-.247.519.519 0 00.029-.195.626.626 0 00-.472-.604l-.056-.015-.877-.001-.878-.002-.027-.059a1.612 1.612 0 00-1.542-.92z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "filter_svg__clip0_1290_1717"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
}
/* harmony default export */ var filter = (SvgFilter);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/button-new/index.tsx
var button_new = __webpack_require__(76712);
// EXTERNAL MODULE: ./src/components/sheet/index.tsx + 38 modules
var sheet = __webpack_require__(17717);
// EXTERNAL MODULE: ./src/hooks/common/use-experiment.ts + 1 modules
var use_experiment = __webpack_require__(30926);
// EXTERNAL MODULE: ./src/hooks/common/use-mobile.tsx
var use_mobile = __webpack_require__(44621);
// EXTERNAL MODULE: ./src/modules/collection/state/available-choices.ts
var available_choices = __webpack_require__(52419);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./src/tracking/index.ts
var tracking = __webpack_require__(1975);
// EXTERNAL MODULE: ./src/tracking/gtm/index.ts + 1 modules
var gtm = __webpack_require__(71295);
// EXTERNAL MODULE: ./src/modules/collection/components/filter-group/index.tsx
var filter_group = __webpack_require__(7589);
// EXTERNAL MODULE: ./src/modules/collection/components/result-counter/index.tsx
var result_counter = __webpack_require__(5088);
// EXTERNAL MODULE: ./src/modules/collection/components/collection-filter/sort-select/mobile/index.tsx
var mobile = __webpack_require__(14177);
;// CONCATENATED MODULE: ./src/modules/collection/components/collection-filter/mobile/index.tsx

















var FilterMobile = function(param) {
    var appliedFilter = param.appliedFilter, filterConfig = param.filterConfig, activeAllergyFilter = param.activeAllergyFilter, resetFilter = param.resetFilter, toggleFilter = param.toggleFilter, collectionProducts = param.collectionProducts, visibleProducts = param.visibleProducts, sortCallback = param.sortCallback;
    var ref = (0,react.useState)(false), isMenuOpen = ref[0], setIsMenuOpen = ref[1];
    var availableFilterMap = (0,available_choices/* useAvailableFilterMap */.o)(collectionProducts, filterConfig);
    var numberOfActiveFilters = // Add fake filters to the number of active filters
    // @see https://petsdeli.atlassian.net/browse/PT-5632
    appliedFilter.length + activeAllergyFilter.length;
    // In case there are not other filters than the hero filter, we don't want to show the filter button
    var showFilterButton = function(filterConfig) {
        return filterConfig && !Array.isArray(filterConfig) && typeof filterConfig === "object" && (Object.keys(filterConfig).length > 1 || !("hero-filter" in filterConfig));
    };
    var findGroupKey = (0,react.useCallback)(function(t) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        var map = Object.entries(availableFilterMap).find(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), _ = _param[0], conf = _param[1];
            return conf.tags.includes(t);
        });
        return map ? map[0] : String(undefined);
    }, [
        availableFilterMap
    ]);
    var isMobile = (0,use_mobile/* default */.Z)();
    var ref1 = (0,react.useState)([]), prevAppliedFilter = ref1[0], setPrevAppliedFilter = ref1[1];
    (0,react.useEffect)(function() {
        if (isMobile && !isMenuOpen) {
            var removedFilters = prevAppliedFilter.filter(function(filter) {
                return !appliedFilter.includes(filter);
            });
            var addedFilters = appliedFilter.filter(function(filter) {
                return !prevAppliedFilter.includes(filter);
            });
            removedFilters.forEach(function(filter) {
                return (0,tracking/* unselectElement */.ey)({
                    element: [
                        "Filter",
                        findGroupKey(filter),
                        filter
                    ]
                });
            });
            addedFilters.forEach(function(filter) {
                return (0,tracking/* selectElement */.G7)({
                    element: [
                        "Filter",
                        findGroupKey(filter),
                        filter
                    ]
                });
            });
            setPrevAppliedFilter(appliedFilter);
        }
    }, [
        appliedFilter,
        isMobile,
        prevAppliedFilter,
        isMenuOpen,
        findGroupKey
    ]);
    var handleClose = function() {
        setIsMenuOpen(false);
        var isActive = numberOfActiveFilters > 0;
        var eventElement = isActive ? "Apply" : "Close";
        (0,gtm/* gtm */.w)((0,tracking/* selectElement */.G7)({
            element: [
                "Filter",
                eventElement
            ]
        }));
    };
    /**
   * Filter test variant. Apply test only on collection pages.
   * @see https://petsdeli.atlassian.net/browse/PT-6960
   */ var ref2 = (0,use_experiment/* default */.Z)({
        baseEntryId: "1OqYdgeJ1f35J4GCuLskDL"
    }), filterTestVariant = ref2.variant;
    var asPath = (0,router.useRouter)().asPath;
    var shouldApplyFilterTestVariant = asPath.indexOf("pet-profile") === -1 && asPath.indexOf("unvertraeglichkeiten-allergien") === -1;
    var variant = shouldApplyFilterTestVariant ? filterTestVariant : 0;
    if (!filterConfig) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center justify-between py-1.5 text-sm text-text-secondary",
                children: variant === 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(result_counter/* default */.Z, {
                    productCount: visibleProducts.length
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("flex items-center justify-between py-1.5 text-sm text-text-secondary", variant === 2 && "gap-2"),
                "data-test": "collection-filter",
                children: [
                    variant !== 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(result_counter/* default */.Z, {
                        productCount: visibleProducts.length
                    }),
                    filterConfig && showFilterButton(filterConfig) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            variant === 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {
                                className: "flex-1 shrink-0 basis-1/2",
                                onChange: sortCallback
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: classnames_default()("flex items-center gap-2 leading-5", variant !== 0 && "flex w-1/3 justify-center rounded-full border border-other-divider px-4 py-2 text-center", variant === 2 && "flex-1 basis-1/2"),
                                onClick: function() {
                                    setIsMenuOpen(function(prevState) {
                                        return !prevState;
                                    });
                                    (0,gtm/* gtm */.w)((0,tracking/* selectElement */.G7)({
                                        element: [
                                            "Filter",
                                            "Toggle"
                                        ]
                                    }));
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "cdp:filter:label"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "relative inline-block ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(filter, {
                                                className: "h-[14px] w-[14px]"
                                            }),
                                            numberOfActiveFilters > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: " absolute -right-1 top-0 -mt-1 mr-0.5 h-1.5 w-1.5 rounded-full bg-red-600"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(sheet/* default */.Z, {
                isOpen: isMenuOpen,
                onClose: handleClose,
                disableScrollLocking: isMenuOpen,
                children: [
                    filterConfig && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-[60px] h-full flex-auto overflow-y-auto px-4",
                        children: filterConfig && /*#__PURE__*/ (0,jsx_runtime.jsx)(filter_group/* default */.Z, {
                            filterConfig: filterConfig,
                            appliedFilter: appliedFilter,
                            toggleFilter: toggleFilter,
                            collectionProducts: collectionProducts,
                            visibleProducts: visibleProducts
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "absolute bottom-0 flex w-full gap-5 bg-other-white px-4 py-3 shadow-sm",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_new/* default */.Z, {
                                size: "base",
                                layout: "outline",
                                styleDisabled: numberOfActiveFilters === 0,
                                disabled: numberOfActiveFilters === 0,
                                onClick: function() {
                                    (0,gtm/* gtm */.w)((0,tracking/* selectElement */.G7)({
                                        element: [
                                            "Filter",
                                            "Unselect All"
                                        ]
                                    }));
                                    resetFilter();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "cdp:resetfilters"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_new/* default */.Z, {
                                size: "base",
                                onClick: handleClose,
                                children: numberOfActiveFilters ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        visibleProducts.length + " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                            id: visibleProducts.length === 1 ? "cdp:filter:showproduct" : "cdp:filter:showproducts"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "cdp:filter:close"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var collection_filter_mobile = (FilterMobile);


/***/ }),

/***/ 7589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var hooks_common_use_mobile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44621);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44012);
/* harmony import */ var tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1975);
/* harmony import */ var utils_strings__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92918);
/* harmony import */ var _components_typography_small_caps__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75464);
/* harmony import */ var _state_available_choices__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52419);
/* harmony import */ var _filter_group_module_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(65044);
/* harmony import */ var _filter_group_module_css__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_filter_group_module_css__WEBPACK_IMPORTED_MODULE_9__);










/**
 * Component that renders a the filters grouped by the filter key.
 * AT the moment we use "fake filters" to test the following fake door test.
 * https://petsdeli.atlassian.net/browse/PT-5632
 * These filters just track the user interaction and don't filter the products.
 */ var FilterGroup = function(param) {
    var filterConfig = param.filterConfig, appliedFilter = param.appliedFilter, toggleFilter = param.toggleFilter, collectionProducts = param.collectionProducts, visibleProducts = param.visibleProducts;
    var isMobile = (0,hooks_common_use_mobile__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var availableFilterMap = (0,_state_available_choices__WEBPACK_IMPORTED_MODULE_6__/* .useAvailableFilterMap */ .o)(collectionProducts, filterConfig);
    var visibleTagsSet = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return new Set(visibleProducts.flatMap(function(product) {
            return product.tags.map(function(tag) {
                return (0,utils_strings__WEBPACK_IMPORTED_MODULE_7__/* .slugify */ .lV)(tag);
            });
        }));
    }, [
        visibleProducts
    ]);
    var isFilterAvailable = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(value) {
        return visibleTagsSet.has(value);
    }, [
        visibleTagsSet
    ]);
    if (!Object.keys(availableFilterMap)) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: Object.keys(availableFilterMap).filter(function(filterKey) {
            return availableFilterMap[filterKey].tags.length > 0;
        })// Hide filters that we don't want to show to the user
        .filter(function(filterKey) {
            return filterKey !== "hidden";
        }).filter(function(filterKey) {
            return filterKey !== "hero-filter";
        })// Hide filters that are for the fake door test
        // @see https://petsdeli.atlassian.net/browse/PT-5632
        .filter(function(filterKey) {
            return !filterKey.includes("fake");
        }).map(function(filterKey) {
            var ref;
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mb-6",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_typography_small_caps__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            "data-test": "filtercatagory_".concat(filterKey),
                            className: "mb-4 lg:mb-3",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                id: "cdp:filter:" + filterKey,
                                defaultMessage: filterKey
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                        children: (ref = availableFilterMap[filterKey]) === null || ref === void 0 ? void 0 : ref.tags.map(function(value) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "mb-4 text-sm last:mb-0",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex items-center", !isFilterAvailable(value) ? "cursor-default text-grey-400" : "cursor-pointer text-text-primary"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                            type: "checkbox",
                                            checked: appliedFilter.includes(value),
                                            disabled: !isFilterAvailable(value),
                                            onChange: function() {
                                                toggleFilter(value);
                                                var eventActionSelect = function() {
                                                    return (0,tracking__WEBPACK_IMPORTED_MODULE_4__/* .selectElement */ .G7)({
                                                        element: [
                                                            "Filter",
                                                            filterKey,
                                                            value
                                                        ]
                                                    });
                                                };
                                                var eventActionUnselect = function() {
                                                    return (0,tracking__WEBPACK_IMPORTED_MODULE_4__/* .unselectElement */ .ey)({
                                                        element: [
                                                            "Filter",
                                                            filterKey,
                                                            value
                                                        ]
                                                    });
                                                };
                                                if (!isMobile) {
                                                    appliedFilter.includes(value) ? (0,tracking__WEBPACK_IMPORTED_MODULE_4__/* .gtm */ .wT)(eventActionUnselect()) : (0,tracking__WEBPACK_IMPORTED_MODULE_4__/* .gtm */ .wT)(eventActionSelect());
                                                }
                                            },
                                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("mr-2.5", (_filter_group_module_css__WEBPACK_IMPORTED_MODULE_9___default().customCheckboxFilter))
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            "data-test": "".concat(filterKey, "_filter_option_").concat(value),
                                            className: "text-left",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                id: "cdp:filter:".concat(filterKey, ":").concat(value),
                                                defaultMessage: value
                                            })
                                        })
                                    ]
                                })
                            }, value);
                        })
                    })
                ]
            }, filterKey);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FilterGroup);


/***/ }),

/***/ 19875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44747);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);





/**
 * Component to group bestseller products.
 * It is expected to used in the grid css
 */ var BestSellerWrapper = function(_param) {
    var children = _param.children, _isMobile = _param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, className = _param.className, bestSellerLength = _param.bestSellerLength, message = _param.message, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children",
        "isMobile",
        "className",
        "bestSellerLength",
        "message"
    ]);
    /**
   * Remove Unsere from message and make best seller bold
   */ var _message = message;
    if (_message && typeof _message === "string") {
        var match = _message.match(/(.*?)(Unsere\s)?(Bestseller)(.*)/);
        if (match) {
            _message = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    match[1],
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "font-mindset text-2xl  font-normal  tracking-wide",
                        children: match[3]
                    }),
                    match[4]
                ]
            });
        }
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("lg:col-span-".concat(bestSellerLength), "relative left-1/2 right-1/2 -mx-[50vw] flex w-screen flex-col lg:static lg:mx-0 lg:w-auto"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("w-full bg-badge-bestseller py-2", "lg:rounded-lg lg:px-2", className)
        }, otherProps), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "px-4 lg:px-0! lg:container",
                children: [
                    message && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        id: "bestSellerWrapperMessage",
                        className: "inline-block px-2 mb-4 text-primary-main",
                        "data-test": "bestseller-wrapper-message",
                        children: _message
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("grid grow gap-3 lg:gap-5", isMobile ? "grid-cols-1" : "grid-cols-".concat(bestSellerLength)),
                        "data-test": "bestseller-wrapper-grid",
                        children: children
                    })
                ]
            })
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BestSellerWrapper);


/***/ }),

/***/ 5088:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44012);



var ResultCounter = function(param) {
    var _productCount = param.productCount, productCount = _productCount === void 0 ? 0 : _productCount;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "text-sm leading-5 text-text-secondary",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            id: "cdp:general:products",
            values: {
                amount: productCount
            }
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ResultCounter);


/***/ }),

/***/ 52419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ useAvailableFilterMap; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_strings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92918);


/**
 * Filter out applicable tags as filter values for CDP based on collection from filterConfig.tags,
 */ var useAvailableFilterMap = function(collectionProduct, filterConfig) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(filterConfig || {}), availableChoices = ref[0], setAvailableChoices = ref[1];
    var convertedTags = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var slugifyiedTags = collectionProduct.map(function(product) {
            return product.tags.map(function(tag) {
                return (0,_utils_strings__WEBPACK_IMPORTED_MODULE_1__/* .slugify */ .lV)(tag);
            });
        }).flat();
        // return only unique
        return Array.from(new Set(slugifyiedTags));
    }, [
        collectionProduct
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!collectionProduct || collectionProduct.length === 0) {
            setAvailableChoices({});
            return;
        }
        if (!filterConfig) {
            return;
        }
        var _config = JSON.parse(JSON.stringify(filterConfig));
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.keys(_config)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                if (_config[key]) {
                    var ref;
                    var _tags = ((ref = _config[key]) === null || ref === void 0 ? void 0 : ref.tags) || [];
                    // use as any since while we know that this wouldn't be undefined
                    (_config[key]).tags = _tags.filter(function(tag) {
                        return convertedTags.includes(tag);
                    });
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setAvailableChoices(_config);
    }, [
        collectionProduct,
        convertedTags,
        filterConfig
    ]);
    return availableChoices;
};


/***/ }),

/***/ 65044:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customCheckboxFilter":"filter-group_customCheckboxFilter__pwPBQ"};

/***/ })

}]);